import axios from '@/core/http'

const fetchRegions = () => {
  return axios.get('sources/regions/').then(res => res.data)
}

export { fetchRegions }
